import { useEffect, useState } from 'react';

export function useTimeout() {
	const [timeoutID, setTimeoutID] = useState<NodeJS.Timeout>(null);

	useEffect(() => {
		return () => {
			clearTimeout(timeoutID);
		};
	}, [timeoutID]);

	return {
		setTimeoutID,
	};
}
